import pick from 'lodash/pick';

import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'react-magma-dom';

const InputComponent = props => {
  const { id, error, name, label, placeholderValue, touched } = props;
  return (
    <Input
      id={id || name}
      testId="inputComponent"
      labelText={label}
      errorMessage={touched && error}
      placeholder={placeholderValue}
      {...pick(props, [
        'type',
        'step',
        'value',
        'pattern',

        'min',
        'max',

        'onBlur',
        'onFocus',
        'onChange',
        'disabled'
      ])}
    />
  );
};

InputComponent.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  placeholderValue: PropTypes.string,
  touched: PropTypes.bool
};

InputComponent.defaultProps = {
  id: null,
  error: null
};

export default InputComponent;
